import classNames from 'classnames'
import { memo, useCallback, useState } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'
import { Messages } from './messages'

export const ChatLive = memo(() => {
  const [filter, setFilter] = useState<'all' | 'gifts' | 'chat'>('all')

  const handleChangeFilter = useCallback(
    (value: string) => {
      setFilter(value as 'all' | 'gifts' | 'chat')
    },
    [setFilter],
  )

  const { translate } = useTranslate()

  const tabClassName = (isActive: boolean) =>
    classNames(
      'inline-flex items-center justify-center rounded-full px-3 py-[3px] text-[11px] font-bold tracking-[0.04em] leading-[16px] cursor-pointer select-none transition-all',
      {
        'bg-hug-purple text-white shadow-[0_2px_10px_rgba(155,48,230,0.45)]':
          isActive,
        'bg-black/35 text-white/70': !isActive,
      },
    )

  return (
    <div className="w-screen h-screen flex flex-col text-white overflow-hidden">
      <div className="flex flex-row items-center gap-1.5 transition-all mb-1.5 w-72 bg-transparent">
        <span
          className={tabClassName(filter === 'all')}
          onClick={() => handleChangeFilter('all')}
        >
          {translate('chat-live-all')}
        </span>

        <span
          className={tabClassName(filter === 'chat')}
          onClick={() => handleChangeFilter('chat')}
        >
          CHAT
        </span>

        <span
          className={tabClassName(filter === 'gifts')}
          onClick={() => handleChangeFilter('gifts')}
        >
          {translate('chat-live-gifts')}
        </span>
      </div>

      <Messages filter={filter} />
    </div>
  )
})
